var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticStyle:{"text-align":"center"}},[_c('p',[_vm._v("A carregar "+_vm._s(_vm.message)+"...")]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100","width":"10","color":"indigo accent-4"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }